<template>
  <div>
    <Button type="primary" @click="openAddModal">新增</Button>

    <Table :columns="columns" :data="personList" > </Table>

    <Modal
      v-model="modalVisible"
      title="新增人物"
      width="1000"
      :loading="loading"
      @on-ok="handleSubmit"
      @on-cancel="handleCancel"
    >
      <Form ref="personForm" :model="formData" :rules="rules" :label-width="120">
        <FormItem label="价格" prop="price">
          <InputNumber :max="100000000" :min="0" v-model="formData.price"></InputNumber>
        </FormItem>
        <FormItem label="等级" prop="lv">
          <Input placeholder="请输入等级" v-model="formData.lv"></Input>
        </FormItem>
        <FormItem label="正面图" prop="frontImage">
          <single-upload title="上传正面图" @update:image="updateFrontImage" />
        </FormItem>
        <FormItem label="背面图" prop="backImage">
          <single-upload title="上传背面图" @update:image="updateBackImage" />
        </FormItem>
        <FormItem label="名称" prop="pname">
          <Input placeholder="请输入名称" v-model="formData.pname"></Input>
        </FormItem>
        <FormItem label="选择性别">
            <RadioGroup v-model="formData.sex">
              <Radio label="0">女</Radio>
              <Radio label="1" checked>男</Radio>
            </RadioGroup>
          </FormItem>
        <FormItem label="备注" prop="remarks">
          <Input placeholder="请输入备注" v-model="formData.remarks"></Input>
        </FormItem>
        <FormItem label="解锁条件" prop="remarks">
          <Input placeholder="解锁条件" v-model="formData.locktitle"></Input>
        </FormItem>
        
      </Form>
    </Modal>
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {    cmsPresonAdd, cmsPresonList, cmsPresonEdit } from "../../api/person.js";
import { formatOssUrl } from "@/utils";

export default {
  name: 'PersonList',
  components: { SingleUpload },
  
  data() {
    return {
      modalVisible: false,
      loading: false,
      personList: [],
      clickmachineid: "",
      formData: {
        price: 0,
        lv: '',
        pname: '',
        remarks: '',
        frontImage: '',
        backImage: '',
        sex: '1',
        locktitle:''
      },

      rules: {
        price: [{ required: true, message: '请输入价格', type: 'number' }],
        lv: [{ required: true, message: '请输入等级' }],
        pname: [{ required: true, message: '请输入名称' }],
        frontImage: [{ required: true, message: '请上传正面图' }],
        backImage: [{ required: true, message: '请上传背面图' }],
      },

      columns: [
        { title: "ID", key: "id" },
        {
          title: "正面图",
          key: "frontImage",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.img1),
                alt: "正面图"
              },
              style: {
                width: "50px",
                height: "100px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "背面图",
          key: "backImage",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.img2),
                alt: "背面图"
              },
              style: {
                width: "50px",
                height: "100px",
                marginTop: "5px",
              },
            });
          },
        },
        { title: "等级", key: "lv" },
        { title: "价格", key: "price" },
        { title: "名称", key: "pname" },
        { title: "备注", key: "remarks" },
        {
          title: "状态",
          key: "nstatus",
          render: (h, params) => {
            const statusMap = {
              '0': '未上架',
              '1': '上架中',
              '2': '已下架'
            };
            return h("span", statusMap[params.row.nstatus] || '未知状态');
          },
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              params.row.nstatus === 0  || params.row.nstatus === 2   
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.id;
                          this.updateMachineStatus(1);
                        },
                      },
                    },
                    "上架"
                  )
                : null,
              params.row.nstatus === 1 
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.id;
                          this.updateMachineStatus(2);
                        },
                      },
                    },
                    "下架"
                  )
                : null,
            ]);
          },
        },
      ],
    };
  },

  mounted() {
    this.fetchPersonList();
  },

  methods: {
    openAddModal() {
      this.resetForm();
      this.modalVisible = true;
    },

    resetForm() {
      this.formData = {
        price: 0,
        lv: '',
        pname: '',
        remarks: '',
        frontImage: '',
        backImage: '',
        sex: '1',
        locktitle:''
      };
      if (this.$refs.personForm) {
        this.$refs.personForm.resetFields();
      }
    },

    updateFrontImage(value) {
      this.formData.img1 = value;
    },

    updateBackImage(value) {
      this.formData.img2 = value;
    },

    async fetchPersonList() {
      try {
        const res = await cmsPresonList({});
        this.personList = res.data;
      } catch (error) {
        this.$Message.error('获取列表失败');
        console.error('获取列表失败:', error);
      }
    },

    updateMachineStatus(status) {
      cmsPresonEdit({ nstatus: status, id: this.clickmachineid }).then(
        (res) => {
          this.fetchPersonList();
        }
      );
    },

    async handleSubmit() {
        await cmsPresonAdd({
          ...this.formData,
          createtime: new Date().toISOString(),
        });
        
        this.$Message.success('添加成功');
        this.modalVisible = false;
        await this.fetchPersonList();
      
    },

    handleCancel() {
      this.resetForm();
      this.modalVisible = false;
    },
  },
};
</script>

<style scoped>
.ivu-table img {
  border-radius: 4px;
}
</style>